import { create } from "zustand";

import axios from "../helper/axios";



const useJobApplicationStore = create((set) => ({
    linkedApplication:null,
    linkedApplicationError:"",
    linkedProfileResume:null,
    linkedApplicationStatus: "",
    linkedJd:null,
    recruitingOrg:"",
            
    getLinkedApplicationByJD: async (qhoid,jdid,qhuid,rid) => {
        let date = new Date();
        let timestamp = date.getTime();
        try {
           const response = await axios.get(`/getLinkedApplication/${qhoid}/${qhuid}/jds/${jdid}/${rid}/${timestamp}`);
            console.log("Linked Data",response.data.name);
            console.log(response.data);
            console.log(response.data.jd);

            set({ linkedApplication: response?.data.data });
            set({ linkedProfileResume: response?.data.resumeData });
            set({ linkedJd: response?.data.jd });
            set({ linkedApplicationStatus: response?.data.status  });
            set({ recruitingOrg: response?.data.recruitingOrg });

        } catch (err) {
            console.log("Linked Data Error",err);
            console.log(err.response.data.jd);
            console.error(err);
        }
    },
    updateProfileInLinkedApplication: async (body) => {
        try {
            console.log(body);
            const response = await axios.post(
                `/updatelinkedcandidateprofile/${body.qhoid}/${body.qhuid}/jds/${body.jdID}/${body.resumeID}`,
                body.jasonValues
            );
            console.log(response.data);
            set({ linkedApplicationStatus: response?.data.status  });            
        } catch (err) {
            console.log("Linked Update Error",err);
            console.error(err);
        }
    },
    resetSelectedApplication: async (jdid,id) => {
        set({ linkedApplication: null });
    },
    resetLinkedApplicationStatus: async (jdid,id) => {
        set({ linkedApplicationStatus: "" });
    },          
                      
}));



export default useJobApplicationStore;
